const RefreshToken_mutate = `
    mutation RefreshToken($refreshToken: String!) {
	  refreshToken(refreshToken: $refreshToken) {
		token
		payload
		refreshToken
		refreshExpiresIn
	  }
	}
`;

const ForgetPassword_mutate = `
    mutation forgetPassword(
      $email: String!) {
      forgetPassword(
        email: $email) {
        userId
		email
      }
    }
`;

const ResetPassword_mutate = `
    mutation resetPassword(
      $password: String!,
	  $forgetCode: String!) {
      resetPassword(
        password: $password,
		forgetCode: $forgetCode) {
        userId
      }
    }
`;

const ChangePassword_mutate = `
  mutation changePassword(
    $email: String!,
    $password: String!) {
      changePassword(
        email: $email,
        password: $password,
      ) {
        userId
        password
      }
    }
`;

const ActivateUser_mutate = `
    mutation activateUser($activationCode: String!) {
      activateUser(activationCode: $activationCode) {
        userId
       activationCode
      }
    }
`;

const CurrentUserDataByEmail_query = `query($email: String!){
  currentUserDataByEmail(email: $email){
    avatarFileName
  }
}`;

const SetAvatar_mutate = `
    mutation setAvatarImage($avatarFile: Upload!, $avatarFileName: String!) {
      setAvatarImage(avatarFile: $avatarFile,avatarFileName: $avatarFileName) {
        userId
      }
    }
`;

const SetCoverImage_mutate = `
    mutation setCoverImage($coverImageFile: Upload!, $coverImage: String!) {
      setCoverImage(coverImageFile: $coverImageFile, coverImage: $coverImage) {
        userId
      }
    }
`;

const UserDataByUuid_query = `query($uuid: String!){
  userDataByUuid(uuid: $uuid){
    username
    firstName
    lastName
    avatarFileName
    coverImage
    city
    state
    country
    address
    zip
    followingNo
    followerNo
    ratingNo
    ratingCount
    email
    birthDate
    dateJoined
    phoneNo 
    bio
    idleTime
    shipsIn
    userUuid
    autoLogin
    emailVisibility
    phoneNoVisibility
    addressVisibility
    listings
    soldToys
    storiesNo
    videosNo
  }
}`;

const UpdateProfile_mutate = `
    mutation updateProfile($inputData: UserInput!) {
      updateProfile(inputData: $inputData) {
        userId
      }
    }
`;

const AllUsers_query = `query{
  allUsers{
    id
    userUuid
    firstName
    lastName
    username
    email
    avatarFileName
    listings
    soldToys
    ratingNo
    ratingCount
    dateJoined
    isActive
    isSuperuser
  }  
}`;

const UpdateUserStatus_mutate = `
    mutation updateUserStatus(
      $userUuid: String!,
      $isActive: Boolean!,
      ) {
      updateUserStatus(
        userUuid: $userUuid,        
        isActive: $isActive) {
        
        user
        {
          id
          userUuid
          username
        }
      }
    }
`;

module.exports = {
  ACTIVATE_USER_MUTATION: ActivateUser_mutate,
  CHANGE_PASSWORD_MUTATION: ChangePassword_mutate,
  CURRENT_USER_DATA_BY_EMAIL: CurrentUserDataByEmail_query,
  FORGET_PASSWORD_MUTATION: ForgetPassword_mutate,
  REFRESH_TOKEN_MUTATION: RefreshToken_mutate,
  RESET_PASSWORD_MUTATION: ResetPassword_mutate,
  SET_AVATAR_IMAGE_MUTATION: SetAvatar_mutate,
  SET_COVER_IMAGE_MUTATION: SetCoverImage_mutate,
  USER_DATA_BY_UUID: UserDataByUuid_query,
  UPDATE_PROFILE_MUTATION: UpdateProfile_mutate,
  ALL_USERS_QUERY: AllUsers_query,
  UPDATE_USER_STATUS_MUTATION: UpdateUserStatus_mutate,
};
